// extracted by mini-css-extract-plugin
export default {"root":"Window98_root__QjHyS","content":"Window98_content__8V0BR"};